import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { getFontURL } from 'src/utils/getFontUrl';
import { trackingList } from 'src/utils/valueHTML';

const TEXT_2_JUSTIFY = {
  left: 'start',
  center: 'center',
  right: 'end'
};

const BasicFullImageHTML: FC = () => {
  let templateWidth = useSelector((state: any) => state.template.templateWidth);
  let templateHeight = useSelector(
    (state: any) => state.template.templateHeight
  );
  let bgColor = useSelector((state: RootState) => state.imageUpload.bgColor);
  let bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  let radius = useSelector((state: RootState) => state.imageUpload.radius);
  let deeplink = useSelector((state: RootState) => state.imageUpload.deeplink);

  let text = useSelector((state: RootState) => state.editText.text);
  let fontSize = useSelector((state: RootState) => state.editText.fontSize);
  let fontWeight = useSelector((state: RootState) => state.editText.fontWeight);
  let color = useSelector((state: RootState) => state.editText.color);
  let fontFamily = useSelector((state: RootState) => state.editText.fontFamily);
  let textAlign = useSelector((state: RootState) => state.editText.textAlign);

  let btnText = useSelector((state: RootState) => state.buttons.btnText);
  let btnFontSize = useSelector(
    (state: RootState) => state.buttons.btnFontSize
  );
  let btnFontWeight = useSelector(
    (state: RootState) => state.buttons.btnFontWeight
  );
  let btnColor = useSelector((state: RootState) => state.buttons.btnColor);
  let btnBgColorR = useSelector(
    (state: RootState) => state.buttons.btnBgColorR
  );
  let btnBgColorG = useSelector(
    (state: RootState) => state.buttons.btnBgColorG
  );
  let btnBgColorB = useSelector(
    (state: RootState) => state.buttons.btnBgColorB
  );
  let btnBgColorA = useSelector(
    (state: RootState) => state.buttons.btnBgColorA
  );
  let btnFontFamily = useSelector(
    (state: RootState) => state.buttons.btnFontFamily
  );
  let btnAgain = useSelector((state: RootState) => state.buttons.btnAgain);

  let tracking = useSelector((state: RootState) => state.trackings.tracking);
  let button1 = useSelector((state: RootState) => state.trackings.button1);
  let button2 = useSelector((state: RootState) => state.trackings.button2);

  let currentUser = useSelector((state: RootState) => state.client.userCompany);

  const btnFontLeftURL = getFontURL(btnFontFamily?.left_button);
  const btnFontRightURL = getFontURL(btnFontFamily?.right_button);
  // const btnFontLeftURL = `https://workspace.inappmessage.com/${currentUser}/font/${btnFontFamily.left_button}`;
  // const btnFontRightURL = `https://workspace.inappmessage.com/${currentUser}/font/${btnFontFamily.right_button}`;

  const plusImageUrl = 'https://i.ibb.co/qMpSJ4w/Group-20.png';
  const style = `
  @font-face {
    font-family: 'btnFontLeft';
    src: url(${btnFontLeftURL});
  }

  @font-face {
    font-family: 'btnFontRight';
    src: url(${btnFontRightURL});
  }


    /* reset */
    * {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
      list-style: none;
      text-decoration: none;
      
    }
    html,
    body {
      height: 100%;
      overflow: hidden;
    }
    main {
      height: 100%;
      position: relative;
    }
    a {
      color: #000000;
      cursor: pointer;
    }
    button {
      background: none;
      border: none;
    }

    /* custom */
    .root {
      ${
        bgImage?.background || bgImage?.background !== ''
          ? `background-image: url(${bgImage?.background});`
          : `background: rgba(0, 0, 0, 0.8);`
      };
      width: 100%;
      height: 100%;

      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      position: relative;
    }
    .click_wrapper {
      width: 100%;
      height: calc(100% - 4.5rem);
      cursor: pointer;
      position: absolute;
      top: 0;
    }

    .modal_wrapper {
      width: 100%;
      line-height: 1.15456rem;
      padding: 1rem;
      padding-top: 2rem;

      display: flex;
      flex-direction: column;
      text-align: center;

      position: absolute;
      top: 50%;
      transform: translate(0%, -50%);

      color: #fff;
      font-size: 0.78513rem;
      font-weight: 400;
      font-family: Roboto;
    }

    .plus_btn button {
      width: 1.1rem;
      height: 1.1rem;
      
      background-image: url(${plusImageUrl});
      background-repeat: no-repeat;
      background-size: 1.1rem;
      background-position: center;

      font-size: 0;
      border: none;
      border-radius: 50%;
      background-color: transparent;
    }

    .bottom_btn {
      width: 100%;
      height: 4.5rem;
      padding: 1rem 2.25rem;
      padding-bottom: 1.5rem;

      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 1rem;

      position: absolute;
      bottom: 0;
      background-color: #fff;
    }
    .bottom_btn button {
      border: 0;
      letter-spacing: 0.0225rem;
    }
    .bottom_btn .style01 {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      text-align: left;
      font-size: ${btnFontSize?.left_button}rem;
      font-weight: ${btnFontWeight?.left_button};
      color: ${btnColor?.left_button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins'].includes(
          btnFontFamily?.left_button
        )
          ? btnFontFamily?.left_button
          : 'btnFontLeft'
      };
      background-color:rgba(${btnBgColorR?.left_button},${
    btnBgColorG?.left_button
  }, ${btnBgColorB?.left_button}, ${btnBgColorA?.left_button});
    }
    .bottom_btn .style02 {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      
      text-align: right;
      font-size: ${btnFontSize?.right_button}rem;
      font-weight: ${btnFontWeight?.right_button};
      color: ${btnColor?.right_button};
      
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins'].includes(
          btnFontFamily?.right_button
        )
          ? btnFontFamily?.right_button
          : 'btnFontRight'
      };
      background-color:rgba(${btnBgColorR?.right_button},${
    btnBgColorG?.right_button
  }, ${btnBgColorB?.right_button}, ${btnBgColorA?.right_button});
    }
  }
  `;

  const html = `
    <div class="root">
      ${
        !bgImage?.background || bgImage?.background === ''
          ? `<div class="modal_wrapper">
          텍스트가 포함된
          <br />
          이미지 또는 배경 이미지를
          <br />
          추가하세요
          <div class="plus_btn">
            <button>plus</button>
          </div>
        </div>`
          : ``
      }
      <div class="click_wrapper"></div>

      <div class="bottom_btn">
        <button class="style01">
          ${btnText?.left_button}
        </button>
        <button class="style02">
          ${btnText?.right_button}
        </button>
      </div>
    </div>
  `;

  let tracking_list = `[`;
  for (let i = 0; i < tracking?.background?.length; i++) {
    tracking_list += `['${tracking?.background?.[i]}', '${tracking?.left_button?.[i]}', '${tracking?.right_button?.[i]}'],`;
  }
  tracking_list += ']';

  let tracking_button_list = trackingList('BASIC FULL IMAGE', button1, button2);
  // let customEvent = "오늘하루 보지않기 클릭_{{campaign.${name}}}";
  const js = `
    document.addEventListener("DOMContentLoaded", function(){
      let tracking = ${tracking_list};
      let button1 = ${tracking_button_list[0]};
      let button2 = ${tracking_button_list[1]};
      $('.click_wrapper').click(function() {
        appboyBridge.logClick(tracking[0][0]);
        try {
          if (button1[0].indexOf(0) !== -1) {
            appboyBridge.logClick('0');
          }
          if (button2[0].indexOf(0) !== -1) {
            appboyBridge.logClick('1');
          }
        } catch (err) {}
        window.location = "${deeplink?.background}";
      });

      $('.style01').click(function() {       
        try {
          if (${btnAgain?.type} === "attribute") {
            appboyBridge.getUser().setCustomUserAttribute("${btnAgain?.left_button}", new Date());
          }
          if (${btnAgain?.type} === "event") {
            appboyBridge.logCustomEvent("${btnAgain?.left_button}");            
          }
        } catch (err) {}

        appboyBridge.logClick(tracking[0][1]);
        try {
          if (button1[1].indexOf(0) !== -1) {
            appboyBridge.logClick('0');
          }
          if (button2[1].indexOf(0) !== -1) {
            appboyBridge.logClick('1');
          }
        } catch (err) {}
        appboyBridge.closeMessage();
      });
      $('.style02').click(function() {
        appboyBridge.logClick(tracking[0][2]);
        try {
          if (button1[2].indexOf(0) !== -1) {
            appboyBridge.logClick('0');
          }
          if (button2[2].indexOf(0) !== -1) {
            appboyBridge.logClick('1');
          }
        } catch (err) {}
        appboyBridge.closeMessage();
      });
    });
  `;

  return (
    <>
      <head>
        <meta charSet="UTF-8" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link
          href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />

        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdn.jsdelivr.net/npm/normalize.css@8.0.1/normalize.css"
        />
        <style dangerouslySetInnerHTML={{ __html: style }}></style>
        <script src="https://code.jquery.com/jquery-3.6.0.min.js"></script>
        <script src="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.js"></script>
      </head>
      <body dangerouslySetInnerHTML={{ __html: html }}></body>
      <script dangerouslySetInnerHTML={{ __html: js }}></script>
    </>
  );
};

export default BasicFullImageHTML;
